import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@sm/wds-react';
import {
  getProductsLinks,
  getSolutionsLinks,
  getResourcesLinks
} from './navSubmenuListItems';

const renderLink = linksData => {
  return (
    <Button
      size="sm"
      color="link"
      variant="text"
      className={`sm-nav-submenu__button wds-float--${linksData.alignment}`}
      href={linksData.url}
    >
      {linksData.title}
      <Icon>]</Icon>
    </Button>
  );
};

export const NavSubmenuBottomLinks = ({ submenuKey, lang }) => {
  let linksData;
  if (submenuKey === 'Products') {
    linksData = getProductsLinks(lang);
  } else if (submenuKey === 'Solutions') {
    linksData = getSolutionsLinks(lang);
  } else {
    linksData = getResourcesLinks(lang);
  }
  return (
    <If condition={lang === 'en'}>
      <div
        className={`sm-nav-submenu__bottom-container sm-nav-submenu--language-${lang}`}
      >
        {linksData[0] && renderLink(linksData[0])}
        {linksData[1] && renderLink(linksData[1])}
      </div>
    </If>
  );
};

NavSubmenuBottomLinks.propTypes = {
  submenuKey: PropTypes.string,
  lang: PropTypes.string
};

NavSubmenuBottomLinks.defaultProps = {
  submenuKey: 'Products',
  lang: 'en'
};

export default NavSubmenuBottomLinks;
